import { render, staticRenderFns } from "./SubscriptionProductsForm.vue?vue&type=template&id=a9a42da8&"
import script from "./SubscriptionProductsForm.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionProductsForm.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionProductsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports